var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"comment"}},[_c('img',{attrs:{"src":require("../assets/img-a46218e4.png"),"id":"a46218e4"}})])
}]

export { render, staticRenderFns }